export function setCookie(key, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + 24 * days * 60 * 60 * 1e3);
    expires = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${key}=${value}${expires}; domain=${window.location.hostname.replace('www', '')};path=/;secure`;
}

export function getCookieValue(cookieName) {
  try {
    const cookiesArray = document.cookie.split(';');
    for (let i = 0; i < cookiesArray.length; i += 1) {
      let x = cookiesArray[i].substr(0, cookiesArray[i].indexOf('='));
      const y = cookiesArray[i].substr(cookiesArray[i].indexOf('=') + 1);
      x = x.replace(/^\s+|\s+$/g, '');
      if (x === cookieName) {
        return unescape(y);
      }
    }
    return '';
  } catch (e) {
  console.error(e) //eslint-disable-line
    return '';
  }
}
